<template>
    <v-container class="loader_container" fluid pa-0 v-bind:class="fullScreen ? 'full-vh' : 'full-percent'">
        <div class="loader_content">
            <!-- <img src="/static/img/loading.svg" alt="loading"/> -->
            <!-- <span v-show="message" style="margin-left: 20px; vertical-align:middle;">{{message}}</span>
            <span v-show="!message" style="margin-left: 20px; vertical-align:middle;">Loading...</span> -->
            <v-progress-circular :size="size" :width="width" color="primary" indeterminate></v-progress-circular>
        </div>
    </v-container>
</template>

<script>
export default {
    name: 'loader',
    props: {
        message: { default: null },
        small: { default: false },
        fullScreen: { default: false }
    },
    data: function () {
        return {
            size: this.small ? 50 : 70,
            width: this.small ? 3 : 5
        }
    }
}
</script>

<style>
.loader_container {
    /* position: absolute; */
    /* width: 100%; */
    background-color: rgb(255, 255, 255);
    /* z-index: 500;
    text-align: center; */
}

.loader_content {
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.full-vh {
    height: 100vh;
}

.full-percent {
    min-height: 200px;
    height: 100%
}
</style>
